import { getTimezoneFromCoordinates } from '@shared/core/places/timezone';

export type TimezoneMethod = 'venue' | 'browser' | 'default';

export type VenueCoordinates = Readonly<{
  lat?: number | null;
  lng?: number | null;
}>;

const VENUE_TIMEZONE_LOOKUP_TIMEOUT_MS = 3000;

export const getTimezone = async (venue?: VenueCoordinates | null): Promise<{ timezoneId: string; timezoneMethod: TimezoneMethod }> => {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const fallbackId = browserTimeZone || 'America/Los_Angeles';
  const fallbackMethod: TimezoneMethod = browserTimeZone ? 'browser' : 'default';

  if (venue?.lat != null && venue?.lng != null) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), VENUE_TIMEZONE_LOOKUP_TIMEOUT_MS);
    try {
      const venueTimezoneId = await getTimezoneFromCoordinates(venue.lat, venue.lng, controller.signal);
      if (venueTimezoneId) {
        return { timezoneId: venueTimezoneId, timezoneMethod: 'venue' };
      }
    } catch {
      // Fall through to browser-timezone fallback.
    } finally {
      clearTimeout(timeoutId);
    }
  }

  return { timezoneId: fallbackId, timezoneMethod: fallbackMethod };
};
